/**
 * Confluence appends a trailing empty paragraph to the live PM doc for cursor
 * placement; mdast strips trailing blank lines on round-trip, so without
 * padding the diff emits a wholesale delete of that paragraph on every
 * writeback. Cosmetic non-collab; collides with concurrent end-of-doc appends
 * under collab.
 */
import { Fragment, type Node as PMNode } from '@atlaskit/editor-prosemirror/model';

const isEmptyParagraph = (node: PMNode | null | undefined): boolean =>
	!!node && node.type.name === 'paragraph' && node.childCount === 0;

export const padTrailingEmptyParagraph = (oldDoc: PMNode, newDoc: PMNode): PMNode => {
	if (!isEmptyParagraph(oldDoc.lastChild)) {
		return newDoc;
	}
	if (isEmptyParagraph(newDoc.lastChild)) {
		return newDoc;
	}
	const paragraphType = newDoc.type.schema.nodes.paragraph;
	if (!paragraphType) {
		return newDoc;
	}
	return newDoc.copy(newDoc.content.append(Fragment.from(paragraphType.create())));
};
